import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const licenseHistorySchema = z.object({
  productId: z.number(),
  productName: z.string().min(1),
  activated: z.boolean(),
  activationDate: coercedDate.nullable(),
  lastConnected: coercedDate.nullable(),
});

export type LicenseHistory = z.infer<typeof licenseHistorySchema>;
